export const discover = {
  // Back button
  'discover.backButton.home': 'Back to home',
  'discover.backButton.homeShort': 'Home',

  // Hero section
  'discover.hero.title': 'Find Your Subsidies',
  'discover.hero.subtitle': 'Intelligent search to find public funding adapted to your project',

  // Toast messages
  'discover.toast.startSearch.title': 'Start your search',
  'discover.toast.startSearch.description': 'Describe your project in the field below.',
  'discover.toast.noResults.title': 'No subsidies found',
  'discover.toast.noResults.description': 'Try broadening your search criteria.',
  'discover.toast.resultsFound.title': '{count} subsidy(ies) found',
  'discover.toast.resultsFound.description': 'Search completed in {time}ms',
  'discover.toast.searchError.title': 'Search error',
  'discover.toast.searchError.description': 'An error occurred during the search. Please try again.',

  // Loading/Transition state
  'discover.loading.analyzing': 'Analyzing...',
  'discover.loading.searchingBest': 'Searching for the best subsidies adapted to your profile',
  'discover.loading.aiWorking': 'Artificial intelligence at work',
  'discover.loading.searchingSubsidies': 'Searching for suitable subsidies...',

  // Results section
  'discover.results.newSearch': 'New search',
  'discover.results.personalizedResults': 'Personalized AI results',
  'discover.results.advancedSearch': 'Advanced search',
  'discover.results.noResults': 'No results available',

  // CTA section
  'discover.cta.title': 'Get personalized help',
  'discover.cta.description': 'Create your profile for complete assistance with your application',
  'discover.cta.createProfile': 'Create my free profile',
  'discover.cta.createProfileShort': 'Create profile',
  'discover.cta.freeAssistance': 'Free assistance',
  'discover.cta.assistance': 'Assistance',

  // Trial tracking
  'discover.trial.remaining': '{count} free trials remaining',
  'discover.trial.remainingSingular': '{count} free trial remaining',
  'discover.trial.lastWarning.title': 'Last free trial',
  'discover.trial.lastWarning.description': 'After this use, create an account to continue using the AI assistant.',
  'discover.trial.exhausted.title': 'Free trial ended',
  'discover.trial.exhausted.description': 'You\'ve used your 3 free searches. Create an account to continue using the AI assistant and unlock more features.',
  'discover.trial.createAccount': 'Create free account',
  'discover.trial.signIn': 'Sign in',

  // Conversational interface
  'discover.input.placeholder': 'Describe your project or situation...',
  'discover.analyzing': 'Analyzing...',
  'discover.conversationalDiscovery': 'Conversational Discovery',
  'discover.assistant.title': 'AI Subsidy Assistant',
  'discover.preferences': 'preferences',

  // Path selector buttons
  'discover.path.business.button': 'Access AI Chatbot',
  'discover.path.individual.button': 'Calculate My Grants',
} as const;
